import Global from "./general/global";
import Nav from "./general/nav";
import Home from "./pages/home";
import Interieuradvies from "./pages/interieuradvies";
import Contact from "./pages/contact";
import Projecten from "./pages/projecten";
import Partners from "./partials/partners";
import Aanbod from "./pages/aanbod";

require('./bootstrap');

new Global();
new Nav();

new Home();
new Interieuradvies();
new Contact();
new Projecten();

new Partners();
new Aanbod();

